module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?c5b8047c33997d2bc442c9fedf354d43";